import type { Geolocation } from "@packages/sdk";

export type GetGeolocationStrictConsentPermissionsProps = {
  geolocation: Geolocation;
};

export const getGeolocationStrictConsentPermissions = ({
  geolocation,
}: GetGeolocationStrictConsentPermissionsProps) => {
  if (geolocation.continent === "EU") return true;

  /** Brazil, South Africa */
  if (["BR", "ZA"].includes(geolocation.country)) return true;

  /** California, Colorado, Connecticut, Delaware, Florida, Iowa, Indiana, Kentucky, Maryland, Minnesota, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, Utah, Virginia */
  if (
    [
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "IA",
      "IN",
      "KY",
      "MD",
      "MN",
      "MT",
      "NE",
      "NH",
      "NJ",
      "OR",
      "RI",
      "TN",
      "TX",
      "UT",
      "VA",
    ].includes(geolocation.regionCode)
  )
    return true;

  return false;
};
